import '../Main.scss';

import {
    Col,
    Row,
} from 'reactstrap';

import * as React from 'react';
import { connect } from 'react-redux';

import {
    GetTenantName,
} from '../../Store/Tenant';

import { BorrowerPortalChildProps } from './BorrowerPortalV2';

import { ApplicationState } from '../../Store';

import { PortalTextBorrowerSharedLinkExpired } from '../../Models/Api/strongbox.financialportal';
import { GetPortalText } from '../../Store/PortalAssets';

import { StringFormat } from '../../Utils/StringUtils';

type InjectedReduxState = {
    linkExpiredText?: PortalTextBorrowerSharedLinkExpired;
    tenantVisibleName: string;
};

type InjectedActionCreators = {};

type Props = InjectedReduxState & InjectedActionCreators & BorrowerPortalChildProps;

export const ShareableLinkExpiredComponent: React.FC<Props> = (props): React.ReactElement => {
    const {
        linkExpiredText,
        tenantVisibleName,
    } = props;

    return (
        <Row
            className={'shareable-link-error-msg-row'}
            style={{
                marginTop: '30px'
            }}
        >
            <Col>
                <p>{linkExpiredText?.explanation1 || ''}</p>
                <p>{StringFormat(linkExpiredText?.templateExplanationPleaseContact || '{0}', tenantVisibleName)}</p>
            </Col>
        </Row>
    )
}

export const ShareableLinkExpired = connect<InjectedReduxState, InjectedActionCreators, BorrowerPortalChildProps, ApplicationState>(
    (appState: ApplicationState) => {
        const result = {
            linkExpiredText: GetPortalText<PortalTextBorrowerSharedLinkExpired>(appState, 'borrowerSharedLinkExpired'),
            tenantVisibleName: GetTenantName(appState),
        };

        return result;
    }
)(ShareableLinkExpiredComponent);
